import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";

import ListingGrid from "../../../common/ListingGrid";

type Props = {
  listings: Array<Object>,
  title: string,
};
// @TODO remove from server side props and rely on API
const ListingGridFeatured = ({ listings, title }: Props) => {
  if (!listings) {
    return null;
  }
  return (
    <ListingGrid
      listings={listings}
      title={title}
      withMargin={false}
      style={{
        padding: "48px 0",
        margin: "0 auto",
      }}
    />
  );
};

export default withGlobalContext(ListingGridFeatured);
